module.exports = __webpack_public_path__ + "media/images/social/google-002119f4fca8d97747f4c871fdf400b7.png";